// trackguard-add-to-cart.js
(function(){
  const SELECTORS = {
    front: '#drop1',
    addButton: '[data-add-to-cart-button], button[name="add"], button#AddToCartButton, add-to-cart-component button[type="submit"]',
    variantInput: 'input[name="id"], select[name="id"]'
  };

  
  // Helper: find variant id on the product page
  function getVariantId() {
    const input = document.querySelector(SELECTORS.variantInput);
    if (!input) return null;
    // select or input
    return input.value || input.options && input.options[input.selectedIndex] && input.options[input.selectedIndex].value || null;
  }

  // Grab button
  function findAddButton() {
    // querySelectorAll to try various possible selectors
    const candidate = document.querySelector(SELECTORS.addButton);
    return candidate;
  }

  // Build item payload
  function buildItemPayload(variantId, quantity, props) {
    return {
      items: [{
        id: parseInt(variantId, 10),
        quantity: parseInt(quantity, 10) || 1,
        properties: props
      }]
    };
  }

  // Simple UI helpers
  function disableButton(btn) {
    btn.dataset.growsDisabled = '1';
    btn.disabled = true;
    btn.classList && btn.classList.add('grows-loading');
  }
  function enableButton(btn) {
    delete btn.dataset.growsDisabled;
    btn.disabled = false;
    btn.classList && btn.classList.remove('grows-loading');
  }

  // Main handler
  function onAddClick(e) {
    // Prevent default only on our button; allow other listeners to run if needed.
    e.preventDefault();
    e.stopImmediatePropagation && e.stopImmediatePropagation();

    const btn = e.currentTarget;
    if (!btn || btn.dataset.growsDisabled) return;

    // read variant
    const variantId = getVariantId();
    if (!variantId) {
      console.warn('GROWS add-to-cart: no variant id found.');
      // Fallback: allow normal flow
      return;
    }

    // read qty if present
    let qtyInput = document.querySelector('input[name="quantity"], input.quantity, input.qty');
    let quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    // read dropdowns
    const front = (document.querySelector(SELECTORS.front) && document.querySelector(SELECTORS.front).value) || '';
    const middle = (document.querySelector(SELECTORS.middle) && document.querySelector(SELECTORS.middle).value) || '';
    const rear = (document.querySelector(SELECTORS.rear) && document.querySelector(SELECTORS.rear).value) || '';

    // prepare properties (only include non-empty)
    const properties = {};
    if (front) properties['weapon'] = front;
    if (middle) properties['middle'] = middle;
    if (rear) properties['rear'] = rear;

    // disable button, show loading state
    disableButton(btn);

    const payload = buildItemPayload(variantId, quantity, properties);

    // POST to /cart/add.js (Shopify storefront API)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(resp => {
      if (!resp.ok) throw new Error('Network response not ok: ' + resp.status);
      return resp.json();
    })
    .then(data => {
      // Success: go to cart (or update cart drawer logic can be added)
      // You can instead call your theme's drawer open function if available
      window.location.href = '/cart';
    })
    .catch(err => {
      console.error('GROWS add-to-cart failed:', err);
      // fall back to the page's normal add-to-cart: trigger the default button behavior
      // Create a hidden form and submit properties as fallback (rare)
      alert('Unable to add to cart automatically — please try again.'); // user feedback
      enableButton(btn);
    });
  }

  // Attach handler once DOM ready
  function init() {
    const addBtn = findAddButton();
    if (!addBtn) {
      // if web component wraps button, try to find actual inner button after a short delay
      setTimeout(() => {
        const addBtn2 = findAddButton();
        if (addBtn2) attach(addBtn2);
      }, 500);
      return;
    }
    attach(addBtn);
  }

  function attach(btn) {
    // If it's an add-to-cart web component, attach listener on its shadow or inner button:
    if (btn.tagName && btn.tagName.toLowerCase() === 'add-to-cart-component') {
      // try to find the inner button
      const innerBtn = btn.querySelector('button[type="submit"]') || btn.shadowRoot && btn.shadowRoot.querySelector('button[type="submit"]');
      if (innerBtn) {
        innerBtn.addEventListener('click', onAddClick);
        return;
      }
      // fallback: listen on the component itself
      btn.addEventListener('click', onAddClick);
      return;
    }
    // normal button
    btn.addEventListener('click', onAddClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
